import { Component, OnInit, OnDestroy, Input,AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import {FileService} from "../../../_services/file.service";
import { BackgroundInfoService } from '../../../_services/index';
import { FutureInfoService } from '../../../_services/index';

import {Http} from "@angular/http";
import {ViewEncapsulation} from "@angular/core";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {MatDialog} from '@angular/material';
import{DialogPdfComponent} from '../dialog-pdf/dialog.component';
import { AuthenticationService } from '../../../_services/index';

@Component({
  selector: 'app-background-information',
  templateUrl: './background-information.component.html',
  styleUrls: ['./background-information.component.css'],
  providers:[FileService,BackgroundInfoService, FutureInfoService]
})
export class BackgroundInformationComponent implements OnInit, OnDestroy {

  backgroundForm: FormGroup;
  formChangeSub: Subscription;
  getdataSub: Subscription;
  submitdataSub: Subscription;
  fileuploadSub: Subscription;
  postSecondarySub: Subscription;
  
  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  submitBtnText = '';
  submitting: boolean;
  fieldErrors:any;
  public personalEmail: string;
  currentUser:any;
  loading:boolean;
  public checkChange: boolean;
  public valueChange = false;
  public canDeactivateCheck = false;
  public checkingSubmit = false;
  public filename;
  public filepath;
  postSecondaryData :any;
  public showCollege;
  highschoolId;
  pdf: any;
  pdfSrc: string = '';
  
  loadingTemplate = '<h1>Loading</h1>';
  isCNIC = false;

  constructor(
    private _fb: FormBuilder,
    private router: Router,
    private _fileService:FileService,
    public api: BackgroundInfoService,
    private route: ActivatedRoute,
    public api2: FutureInfoService,
    public dialog: MatDialog,
    private loginservice: AuthenticationService,

  ) { }

  ngOnDestroy() {

    if (this.formChangeSub) {
      this.formChangeSub.unsubscribe();
    }
    if (this.getdataSub)  {
      this.getdataSub.unsubscribe();
    }
    if (this.submitdataSub)  {
      this.submitdataSub.unsubscribe();
    }
    if (this.fileuploadSub)  {
      this.fileuploadSub.unsubscribe();
    }

  }

  ngOnInit() {
    this.createForm();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.personalEmail=this.currentUser?this.currentUser.email:'';
    this.backgroundForm.get('personalEmail').setValue(this.personalEmail);
    //this.postSecondarysList();
    this.getBackgroundInfo();
    window.scrollTo(300, 500);

    //let data = this.route.data.subscribe(v => console.log(v));
    this.checkCinc();
  }

  ngAfterViewInit() {
    
    var element1 = document.querySelector('.droppable1');
    this.makeDroppable(element1, this.callback,this);

    var element2 = document.querySelector('.droppable2');
    this.makeDroppable(element2, this.callback,this);
   }

   createForm()  {
    this.backgroundForm  = this._fb.group({
      isAttendCollege: ['', [Validators.required]],
      //recentClg: [''],
      isFirstAmong: ['', [Validators.required]],
      fileId: [''],
      personalEmail: ['', [Validators.required]],   
      parentgra1: ['Grade 9 or less'],       
      parentgra2: ['Grade 9 or less'],
      tribalname: [''],
      tribalaff: [''],
      
    });

    this.formChangeSub = this.backgroundForm
    .valueChanges
    .subscribe(data => this._onValueChanged());
    this._onValueChanged();

  }

  showHideCollege(v) {
      if (v == 1) {
          this.showCollege = true;
      } else {
          this.showCollege = false;
      }
  }

  onSubmit()  {

    this.loading = true;
   
    const body = JSON.stringify({
      isAttendCollege: this.backgroundForm.controls.isAttendCollege.value,
      //recentClg: recentClg,
      isFirstAmong: this.backgroundForm.controls.isFirstAmong.value,
      fafsaCalsar: false,
      fileId:this.backgroundForm.controls.fileId.value,
      personalEmail:this.backgroundForm.controls.personalEmail.value,
      parentgra1:this.backgroundForm.controls.parentgra1.value,
      parentgra2:this.backgroundForm.controls.parentgra2.value,
      tribalname:this.backgroundForm.controls.tribalname.value,
      tribalaff:this.backgroundForm.controls.tribalaff.value,

    });
    
    //console.log(body);
    this.submitting = true;
    this.api.postBackgroundInfo$(body)
      .subscribe(
        data => {
          this.error = false;
          this.submitting = false;
          const response = data;
            this.errorFlag = false;
            this.successMessage = response.message;
            if(!this.canDeactivateCheck)
            {
              this.checkingSubmit = true;
              
              this.router.navigate(['/profile/prior-higher-education']);
            }
            this.loading = false;
        },
        error => {
          this.submitting = false;
          this.errorFlag = true;
          const errordata = JSON.parse(error._body);
          if (errordata.success === 0) {
            this.errorMessage = errordata.message;
            this.errorFlag = true;
            this.fieldErrors = errordata.errors;
          }
          this.loading = false;
        },
      );
  }

  private _onValueChanged() {
    //console.log(this.checkChange);
    if(this.checkChange)
    {
      //console.log('back');
      this.valueChange = true
    }
  }

  makeDroppable(element, callback,classObj) {
      var input = document.createElement('input');
      input.setAttribute('type', 'file');
      //input.setAttribute('multiple', 'true');
      input.style.display = 'none';
      input.addEventListener('change', function (e) {
          triggerCallback(e, classObj);
      });
      element.appendChild(input);
      element.addEventListener('dragover', function(e) {
          e.preventDefault();
          e.stopPropagation();
          element.classList.add('dragover');
      });
      element.addEventListener('dragleave', function(e) {
          e.preventDefault();
          e.stopPropagation();
          element.classList.remove('dragover');
      });
      element.addEventListener('drop', function(e) {
          e.preventDefault();
          e.stopPropagation();
          element.classList.remove('dragover');
          triggerCallback(e,classObj);
      });
      element.addEventListener('click', function() {
          input.value = null;
          input.click();
      });
      function triggerCallback(e,obj) {
          var files;
          if(e.dataTransfer) {
              files = e.dataTransfer.files;
          } else if(e.target) {
              files = e.target.files;
          }
          callback.call(null, files,e,obj);
      }
  }

  callback(files, event, classobject?: any) {
      for (let i = 0; i < files.length; i++) {
          classobject.loading = true;
          let ext = '';
          //console.log(files[i]);
          // Here, we simply log the Array of files to the console.
          let mimeType = files[i].type;
          ext = files[i].name.split('.').pop();
          //console.log(ext);
          const allowedMIMEType = ['application/pdf'];
          if(allowedMIMEType.indexOf(mimeType)>= 0 ){
              if((allowedMIMEType.indexOf(mimeType) == 0) || (allowedMIMEType.indexOf(mimeType) == 1) ){

                  classobject.filetype = ext;

              }else{
                  classobject.filetype = ext;

              }
              //console.log(classobject.quoteId);
              const body = {
                  attachableId: '',
                  file: files[i],
                  attachableType:'Background'
              };

              //console.log(body);
              
                    classobject.fileuploadSub = classobject._fileService.uploadFile(body).subscribe(

                    responsedata => {

                    //console.log(responsedata);

                      //classobject.backgroundForm.controls["fileId"].setValue(data.fileId);
                      let fileId = JSON.parse(responsedata._body).data.fileId;
                      //console.log(fileId);
                      classobject.backgroundForm.controls["fileId"].setValue(fileId);
                      classobject.filename = files[i].name;
                       
                      let filelink = JSON.parse(responsedata._body).data.filelink;
                      classobject.filepath = filelink;
                      
                      classobject.loading = false;
                    },
                  error => {

                    classobject.loading = false;

                  });

          }else{

              alert("File not allowed");
              classobject.loading = false;

          }
      }
  //console.log(classobject.uploadFilenames);

  }

  getBackgroundInfo() {
    this.loading = true;
    const body = JSON.stringify({
          email: this.personalEmail
    });
    this.getdataSub = this.api.getBackgroundInfo(body)
      .subscribe(responsedata => {
        let backgroundInfodata = responsedata.data;
        
        if(backgroundInfodata.is_attend_college) {
          this.backgroundForm.controls['isAttendCollege'].setValue(backgroundInfodata.is_attend_college);
          this.showHideCollege(backgroundInfodata.is_attend_college);
        }

        if(backgroundInfodata.college_id) {
          
          this.highschoolId = JSON.parse(backgroundInfodata.college_id).id;
        }

        if(backgroundInfodata.parentgra1) {
          
          this.backgroundForm.controls['parentgra1'].setValue(backgroundInfodata.parentgra1);

        }

        if(backgroundInfodata.parentgra2) {
          
          this.backgroundForm.controls['parentgra2'].setValue(backgroundInfodata.parentgra2);

        }

        if(backgroundInfodata.tribalname) {
          
          this.backgroundForm.controls['tribalname'].setValue(backgroundInfodata.tribalname);

        }

        if(backgroundInfodata.tribalaff) {
          
          this.backgroundForm.controls['tribalaff'].setValue(backgroundInfodata.tribalaff);

        }

        if(backgroundInfodata.fafsa_calsar) {
          //this.backgroundForm.controls['fafsaCalsar'].setValue(backgroundInfodata.fafsa_calsar);
        }

        if(backgroundInfodata.is_first_among) {
          this.backgroundForm.controls['isFirstAmong'].setValue(backgroundInfodata.is_first_among);
        }

        this.filename = backgroundInfodata.orig_name;
        this.filepath = backgroundInfodata.full_path;
        setTimeout(()=>{
          this.loading = true;
          this.checkChange = true;
          this.loading = false;
          
        },2000);
      });
  }

  renderHero = (data: any) : SafeHtml => {
    //console.log(data);
    let html = `<span>${data.name}</span>`;
    return html;
  };

  changePdf(url){

    this.pdfSrc = url;
    //console.log(this.pdfSrc);
    this.openDialog();
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogPdfComponent, {
      height: '600px',
      data: { url: this.pdfSrc }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log(`Dialog result: ${result}`);
    });
  }

  canDeactivate() {

      //console.log('i am navigating away from background');
      
      //console.log(this.valueChange);

      if(this.valueChange  && this.checkingSubmit == false)
      {
        if(confirm("Want to save changes?")) {
            
          this.canDeactivateCheck = true;
          this.onSubmit();
        }
      }
      
      return true;
    
  }

  checkCinc(){
    const getDomainName = this.loginservice.getDomainName();
    const parts = window.location.hostname.split(getDomainName);
    //const countLength = parts.length;
    const subdomain = parts.shift();
    console.log(subdomain);
    if(subdomain == 'cinc'){
      this.isCNIC = true;
    }
    else{
      this.isCNIC = false;
    }
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/background-information/background-information.component.ts